/*
 * @Author: Liux
 * @Date: 2019-12-27 07:57:39
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 14:33:15
 */
import {
  Component,
  OnInit,
  forwardRef,
  Output,
  Input,
  EventEmitter
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'ad-check-box',
  templateUrl: './ad-check-box.component.html',
  styleUrls: ['./ad-check-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdCheckBoxComponent),
      multi: true
    }
  ]
})
export class AdCheckBoxComponent implements OnInit, ControlValueAccessor {
  @Output() disabled = false;
  @Input() text = '';
  @Input() cssClass: any;
  @Input() cssStyle: any;
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();
  @Input('value') set inputValue(val) {
    this.value = val;
    this.onChange.emit({ event: null, value: this.value });
  }
  //#region ngModel
  _value: any;
  get value() {
    return this._value;
  }
  set value(val) {
    this._value = val;
    this.onChangeFun(val);
  }
  onChangeFun: any = () => { };
  onTouchedFun: any = () => { };

  writeValue(obj: any): void {
    this._value = obj;
    this.onChange.emit({ event: null, value: this.value });
  }
  registerOnChange(fn: any): void {
    this.onChangeFun = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedFun = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  //#endregion
  constructor() { }

  ngOnInit() {
    this.value = false;
  }

  clickHandler(event) {
    this.value = !this.value;
    this.onChange.emit({ event, value: this.value });
    this.onClick.emit({ event, value: this.value });
  }
}
